import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config";
const initialState = {
  data: {
    roles: [],
    entities: [],
    initials: null,
    name: null,
  },
  status: "idle",
  error: null, // Will hold any error message if the thunk fails.
};

export const fetchUser = createAsyncThunk(
  "auth/fetchUser",
  async (_, { rejectWithValue }) => {
    try {
      // Fetch user data from the protected endpoint.
      // The browser will automatically send the authentication cookie.
      const response = await fetch(`${config.apiUrl}/auth/userInfo`, {
        credentials: "include",
      });

      // If the response is not ok (e.g., 401 Unauthorized),
      // it means the user is not authenticated.
      if (!response.ok) {
        // We reject the promise with a specific error message.

        return rejectWithValue(
          "Failed to fetch user. User is not authenticated."
        );
      }

      const userData = await response.json();
      return userData;
    } catch (error) {
      // Handle network errors or other exceptions.
      return rejectWithValue(error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  // Reducers for synchronous actions can be defined here if needed.
  reducers: {},
  // 'extraReducers' handle actions generated by createAsyncThunk.
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload; // Store the fetched user data.
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = "failed";
        state.data = null;
        state.error = action.payload; // Store the error message.
      });
  },
});

export default authSlice.reducer;
